import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClientPopupComponent } from './client-popup.component';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from "@angular/material/icon";



@NgModule({
  declarations: [
    ClientPopupComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatIconModule
],
exports:[
  ClientPopupComponent
]
})
export class ClientPopupModule { }
